export const REQUISICOES_SEEN_EVENT = 'requisicoes-seen-updated';

export interface RequisicaoResumo {
  id: number;
  status: string;
}

type SeenMap = Record<string, string>;

const storageKey = (email: string) => `requisicoes_vistas_${email.toLowerCase()}`;

export function getSeenMap(email: string): SeenMap {
  try {
    const raw = localStorage.getItem(storageKey(email));
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function markRequisicaoSeen(email: string, id: number | string, status: string): void {
  const map = getSeenMap(email);
  map[String(id)] = status;
  localStorage.setItem(storageKey(email), JSON.stringify(map));
  window.dispatchEvent(new CustomEvent(REQUISICOES_SEEN_EVENT));
}

export function isRequisicaoUnread(
  req: RequisicaoResumo,
  email: string,
): boolean {
  const seen = getSeenMap(email)[String(req.id)];
  return seen !== req.status;
}

export function countUnreadRequisicoes(
  requisicoes: RequisicaoResumo[],
  email: string,
): number {
  return requisicoes.filter((req) => isRequisicaoUnread(req, email)).length;
}

export function getUnreadRequisicoes<T extends RequisicaoResumo>(
  requisicoes: T[],
  email: string,
): T[] {
  return requisicoes.filter((req) => isRequisicaoUnread(req, email));
}
